import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=37ac052a&scoped=true&"
import script from "./IconPicker.vue?vue&type=script&lang=js&"
export * from "./IconPicker.vue?vue&type=script&lang=js&"
import style0 from "./IconPicker.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./IconPicker.vue?vue&type=style&index=1&id=37ac052a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac052a",
  null
  
)

export default component.exports